exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-detail-box[data-v-5a176efc] {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #991b1b;\n  line-height: 1.5;\n}\n.error-steps[data-v-5a176efc] {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.7;\n}\n.error-steps li[data-v-5a176efc] {\n  margin-bottom: 4px;\n}\n", ""]);

// exports
